import { BaseModel, RecursivePartial } from '@models/base';

export class VzLocalPrefs extends BaseModel {

    lsmWidth: number = 250;
    lsmCollapsed: boolean = false;
    lsmChatsOpened: boolean = true;
    lsmDirectChatsOpened: boolean = true;
    lsmPluginChatsOpened: boolean = true;
    lsmTasksOpened: boolean = true;
    lsmKanbansOpened: boolean = true;
    orgHideFileStats: boolean = false;
    videoDockWidth: number = 600;

    ganttScale: number = 24;
    ganttRow: number = 40;
    ganttTaskData: boolean = true;
    ganttLinkDup: boolean = true;
    ganttLinkLink: boolean = true;
    ganttBgWeekend: boolean = true;
    ganttBgHoliday: boolean = true;
    ganttBgLines: boolean = true;

    wikiTreeWidth: number = 500;
    wikiTreeOpened: boolean = true;
    wikiTocWidth: number = 400;
    wikiTocOpened: boolean = true;

    taskToolbarTop: number = 80;

    noBiometric: boolean = false;
    justAfterLogout: boolean = false;

    constructor(json?: RecursivePartial<VzLocalPrefs>) {
        super(json);
        this.parseVzLocalPrefs(json || {});
    }

    parse(json: RecursivePartial<VzLocalPrefs>): VzLocalPrefs {
        super.parse(json);
        this.parseVzLocalPrefs(json);
        return this;
    }

    private parseVzLocalPrefs(json: RecursivePartial<VzLocalPrefs>): void {
        VzLocalPrefs.assignFields<VzLocalPrefs>(this, json, [
            'lsmWidth',
            'lsmCollapsed',
            'lsmChatsOpened',
            'lsmDirectChatsOpened',
            'lsmPluginChatsOpened',
            'lsmTasksOpened',
            'lsmKanbansOpened',
            'orgHideFileStats',
            'videoDockWidth',
            'ganttScale',
            'ganttRow',
            'ganttTaskData',
            'ganttLinkDup',
            'ganttLinkLink',
            'ganttBgWeekend',
            'ganttBgHoliday',
            'ganttBgLines',
            'wikiTreeWidth',
            'wikiTreeOpened',
            'wikiTocWidth',
            'wikiTocOpened',
            'taskToolbarTop',
            'noBiometric',
            'justAfterLogout'
        ]);
    }
}
